import React from "react";
import { Alert } from "react-bootstrap";

interface Props {
	message: string;
}

const AppErrorMessage = ({ message }: Props) => {
	return (
		<Alert variant="danger" className="w-100 mt-3 mb-5">
			{message}
		</Alert>
	);
};

export default AppErrorMessage;
